import {
  Directive,
  Input,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

class AppSkeletonLoaderContext {
  public $implicit: boolean = true;
  public type: string = 'rectangle';
  public style = {};
}

@Directive({
  selector: '[appSkeletonLoader]',
})
export class SkeletonLoaderDirective implements OnInit {
  @Input() appSkeletonLoaderType: string;
  @Input() appSkeletonLoaderStyle: object;

  private _context: AppSkeletonLoaderContext = new AppSkeletonLoaderContext();
  private _parentNode: any;
  private _placeholderNode: any;

  constructor(
    private templateRef: TemplateRef<any>,
    private renderer2: Renderer2,
    private viewContainer: ViewContainerRef
  ) {
    this._placeholderNode = document.createElement('span');
    this.renderer2.addClass(
      this._placeholderNode,
      'skeleton-loader__placeholder'
    );

    this._parentNode = this.renderer2.parentNode(
      this.templateRef.elementRef.nativeElement
    );
  }

  @Input() set appSkeletonLoader(show: boolean) {
    if (this._context.$implicit !== show) {
      this._context.$implicit = show;
      this.updateView();
    }
  }

  /**
   * Initializes directive
   */
  public ngOnInit(): void {
    this._context.type = this.appSkeletonLoaderType ?? this._context.type;
    this._context.style = this.appSkeletonLoaderStyle;
    if (this._context.$implicit) {
      this.updateView();
    }
  }

  /**
   * Updates view, shows or hides skeleton
   */
  public updateView() {
    if (!this._context.$implicit) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hideSkeleton();
    } else {
      this.viewContainer.clear();
      this.showSkeleton();
    }
  }

  /**
   * Shows skeleton into container
   */
  public showSkeleton(): void {
    this.renderer2.addClass(this._parentNode, 'skeleton-loader');
    this.renderer2.addClass(
      this._parentNode,
      'skeleton-loader--' + this._context.type
    );

    this.renderer2.appendChild(this._parentNode, this._placeholderNode);

    if (this._context.style) {
      Object.keys(this._context.style).forEach((key) => {
        this.renderer2.setStyle(
          this._placeholderNode,
          key,
          this._context.style[key]
        );
      });
    }
  }

  /**
   * Hides skeleton into container
   */
  public hideSkeleton(): void {
    this.renderer2.removeClass(this._parentNode, 'skeleton-loader');
    this.renderer2.removeClass(
      this._parentNode,
      'skeleton-loader--' + this._context.type
    );

    this._parentNode.childNodes.forEach((element) => {
      if (this._placeholderNode.isSameNode(element)) {
        this.renderer2.removeChild(this._parentNode, this._placeholderNode);
      }
    });
  }
}
